/**
 * Przechowywanie tokenów sesji.
 *
 * Token dostępowy żyje wyłącznie w pamięci modułu — nie da się go odczytać
 * z `localStorage`, więc skrypt wstrzyknięty przez XSS ma trudniej.
 * Token odświeżający musi przetrwać odświeżenie strony, więc trafia do
 * `localStorage`; chroni go rotacja i wykrywanie ponownego użycia po
 * stronie serwera.
 */

const REFRESH_KEY = 'legato.refresh_token'

let accessToken: string | null = null

/** Wywoływane, gdy sesja przestaje być ważna — pozwala przekierować na logowanie. */
type SessionExpiredHandler = () => void
let onSessionExpired: SessionExpiredHandler | null = null

export const tokenStorage = {
  getAccessToken(): string | null {
    return accessToken
  },

  setAccessToken(token: string | null): void {
    accessToken = token
  },

  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY)
    } catch {
      // Tryb prywatny w niektórych przeglądarkach blokuje localStorage.
      return null
    }
  },

  setRefreshToken(token: string | null): void {
    try {
      if (token) {
        localStorage.setItem(REFRESH_KEY, token)
      } else {
        localStorage.removeItem(REFRESH_KEY)
      }
    } catch {
      // Brak trwałego magazynu oznacza tylko sesję do zamknięcia karty.
    }
  },

  save(tokens: { access_token: string; refresh_token: string }): void {
    this.setAccessToken(tokens.access_token)
    this.setRefreshToken(tokens.refresh_token)
  },

  clear(): void {
    this.setAccessToken(null)
    this.setRefreshToken(null)
  },

  hasSession(): boolean {
    return Boolean(accessToken ?? this.getRefreshToken())
  },

  onSessionExpired(handler: SessionExpiredHandler | null): void {
    onSessionExpired = handler
  },

  notifySessionExpired(): void {
    this.clear()
    onSessionExpired?.()
  },
}
